import { render } from "./HalfCircle.vue?vue&type=template&id=0d84671d&scoped=true"
import script from "./HalfCircle.vue?vue&type=script&lang=js"
export * from "./HalfCircle.vue?vue&type=script&lang=js"

import "./HalfCircle.vue?vue&type=style&index=0&id=0d84671d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d84671d"]])

export default __exports__